import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=fe3b1764&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=fe3b1764&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3b1764",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Footer: require('/app/appsumo/nuxt/components/common/Footer.vue').default})
